import { styled } from '@mui/system';
import { Button, Typography } from '@mui/material';
import themes from '../../themes/defaultTheme';

export const StyledButton = styled(Button)({
    textTransform: 'None',
    margin: '10px'
});

export const StyledInputRequired = styled(Typography)({
    color: themes.default.palette.error.dark,
    fontStyle: 'italic',
    fontSize: '14px'
});